import type { TButtonSizes } from '~/components/button/types'
import type { SearchBarSize } from '../types'

export const mapButtonSize = (size: SearchBarSize): TButtonSizes => {
  if (size === 'medium-large' || size === 'large') {
    return 'ml'
  }
  return 'md'
}
